import { BatchResultEmpty } from './batch-result-empty';
import { BatchResultItem } from './batch-result-item';
import { CoordinatorService } from './coordinator.service';

export type BATCH_DISPLAY_TYPE = 'biblio' | 'doi' | 'orcid' | 'fulltext';

export class BatchResult {
    id: string;
    type: string;
    title: string;
    service: string;
    batchId: string;
    changeSet = new Set<string>();
    private _itmDataMap = new Map<string, BatchResultItem | BatchResultItem[] | BatchResultEmpty>();

    constructor(
        private coords: CoordinatorService,
        {
            title,
            data,
            batchId,
            type,
            service,
        }: { batchId: string; title: string; type: string; service: string; data: any },
    ) {
        this.id = this.coords.uniqueId();
        this.title = title;
        this.service = service;
        this.batchId = batchId;
        this.type = type;

        switch (this.type || this.service) {
            case 'doi':
            case 'orcid':
            case 'biblio':
            case 'fulltext':
                // console.log('BatchResult: DOI or ORCID service', data);
                Object.keys(data).forEach((k) => {
                    const payload = data[k];
                    if (!payload || Object.keys(payload).length === 0) {
                        const bre = new BatchResultEmpty(this.coords, this);
                        this._itmDataMap.set(k, bre);
                    } else {
                        const bri = new BatchResultItem(this.coords, this, k, data[k]);
                        this._itmDataMap.set(k, bri);
                    }
                });
                // console.log('BatchResult with type', this._itmDataMap);
                break;
            default:
                if (!data) return;
                Object.keys(data).forEach((k) => {
                    if (data[k].length) {
                        let ls = this._itmDataMap.get(k) as BatchResultItem[];
                        if (!ls) {
                            ls = [];
                            this._itmDataMap.set(k, ls);
                        }
                        data[k].forEach((d: any) => {
                            ls.push(new BatchResultItem(this.coords, this, k, d));
                        });
                    } else {
                        this._itmDataMap.set(k, new BatchResultEmpty(this.coords, this));
                    }
                });
        }
    }

    get filterValueLs(): [string, number][] {
        switch (this.service) {
            case 'orcid':
                return [
                    [this.coords.text(`all::batch:${this.id}`), this.size],
                    [this.coords.text(`no-hit::batch:${this.id}`), this.noHitSize],
                ];
            case 'doi':
                return [
                    [this.coords.text(`all::batch:${this.id}`), this.size],
                    [this.coords.text(`suggest::batch:${this.id}`), this.suggestSize],
                    [this.coords.text(`ok::batch:${this.id}`), this.okSize],
                ];
            default:
                return [
                    [this.coords.text(`all::batch:${this.id}`), this.size],
                    [this.coords.text(`no-hit::batch:${this.id}`), this.noHitSize],
                    [this.coords.text(`change::batch:${this.id}`), this.changeSet.size],
                ];
        }
    }

    get size() {
        return this._itmDataMap.size;
    }

    get noHitSize() {
        let i = 0;
        this._itmDataMap.forEach((val) => val instanceof BatchResultEmpty && i++);
        return i;
    }

    get okSize() {
        let i = 0;
        this._itmDataMap.forEach((val) => val instanceof BatchResultItem && val.isOK && i++);
        return i;
    }

    get suggestSize() {
        let i = 0;
        this._itmDataMap.forEach((val) => val instanceof BatchResultItem && val.hasSuggest && i++);
        return i;
    }

    hasId(itmId: string) {
        return this._itmDataMap.has(itmId);
    }

    itmData(itmId: string) {
        return this._itmDataMap.get(itmId);
    }
}
